import React, { useState, useEffect } from 'react';
import { ArrowRight, X } from 'lucide-react';

const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 300) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (!isVisible || isDismissed) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 p-4 md:p-3"
      style={{
        background: 'linear-gradient(to top, var(--bg-primary) 0%, transparent 100%)',
        paddingBottom: '80px' // Space for floating buttons
      }}
    >
      <div 
        className="max-w-4xl mx-auto flex items-center justify-between gap-4 p-4 rounded-lg"
        style={{
          background: 'var(--brand-primary)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)'
        }}
      >
        <div className="flex-1">
          <p className="font-semibold text-black text-sm md:text-base">
            Ready to automate your business with AI?
          </p>
          <p className="text-black/70 text-xs md:text-sm hidden sm:block">
            Book a free strategy call and discover how AI can transform your operations.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <a
            href="https://calendly.com/americanprimeforyou"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 rounded font-medium text-sm whitespace-nowrap transition-all hover:scale-105"
            style={{
              background: '#000000',
              color: '#FFFFFF',
              textDecoration: 'none'
            }}
            onClick={() => {
              if (window.trackCTA) {
                window.trackCTA('Book Strategy Call', 'sticky_cta');
              }
            }}
          >
            <span>Book Free Call</span>
            <ArrowRight size={16} />
          </a>
          <button
            onClick={() => setIsDismissed(true)}
            className="p-2 rounded hover:bg-black/10 transition-colors"
            style={{ color: '#000000', background: 'none', border: 'none', cursor: 'pointer' }}
            aria-label="Dismiss"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
